export const PERMS = {
    READ: 'driver_surcharge_types.read',
    UPDATE: 'driver_surcharge_types.update',
    DELETE: 'driver_surcharge_types.delete',
    CREATE: 'driver_surcharge_types.create',
}
